<template>
  <div class="tab-history-item" :class="{ 'is-child': item.type === 6 && item.children === undefined }">
    <div class="tab-history-item__list-item-date">
      {{ getDate(item.created_at) }}
    </div>

    <div class="tab-history-item__list-item-event">
      <div class="tab-history-item__list-item-type">
        <i
          v-if="item.type === undefined || item.type === null"
          class="icon icon-check tab-history-item__list-item-type--grey"
        ></i>

        <i
          v-else-if="item.type === 1"
          v-tooltip="{
            content: $tr('settings.statuses.add'),
            placement: 'top-center',
            classes: 'tight'
          }"
          class="icon icon-arrows-right-left tab-history-item__list-item-type--blue"
        ></i>
        <i
          v-else-if="item.type === 2"
          v-tooltip="{
            content: $tr('history.email-sent'),
            placement: 'top-center',
            classes: 'tight'
          }"
          class="icon icon-envelope tab-history-item__list-item-type--lilac"
        ></i>

        <i v-if="item.type === 3" class="icon icon-check tab-history-item__list-item-type--grey"></i>

        <i v-if="item.type === 4" class="icon icon-play tab-history-item__list-item-type--green"></i>

        <i v-if="item.type === 5" class="icon icon-flag tab-history-item__list-item-type--green"></i>

        <i
          v-if="item.type === 6 && item.meta === undefined"
          class="icon icon-fraud tab-history-item__list-item-type--yellow"
        ></i>

        <i
          v-if="
            item.type === 6 &&
            item.meta !== undefined &&
            item.meta['cheating-event'] !== undefined &&
            item.meta['cheating-event'] === 'printscreen-pressed'
          "
          class="icon icon-copy tab-history-item__list-item-type--grey"
        ></i>

        <i
          v-if="
            item.type === 6 &&
            item.meta !== undefined &&
            item.meta['cheating-event'] !== undefined &&
            item.meta['cheating-event'] === 'focus-changed'
          "
          class="icon icon-tabswitch tab-history-item__list-item-type--grey"
        ></i>
      </div>

      <div
        class="tab-history-item__list-item-type-text"
        :class="{
          link:
            (item.type === 6 && item.children !== undefined) || (item.type === 6 && item.meta.question_id !== undefined)
        }"
        @click="toggleOrLink(item)"
      >
        {{ getStatusText(item) }}

        <template v-if="item.type === 6 && item.children !== undefined">
          ({{ item.children.length }}) <i class="icon" :class="{ 'icon-fold': isOpened, 'icon-unfold': !isOpened }"></i>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'VcvTabHistoryItem',

  props: {
    item: {
      type: Object,
      default: () => {}
    },

    isOpened: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('dictionary', ['responseStatuses'])
  },

  methods: {
    ...mapMutations('response/tabs', ['setActiveTab']),

    getDate(createdAt) {
      if (this.$moment(createdAt).isSame(new Date(), 'day') || this.$moment(createdAt).diff('days') === -1) {
        return this.$moment(createdAt)
          .parseZone()
          .calendar({
            sameDay: `[${this.$tr('common.today')}], HH:mm`,
            lastDay: `[${this.$tr('common.yesterday')}], HH:mm`,
            sameElse: 'DD MMM YYYY, HH:mm'
          });
      }

      return this.$moment(createdAt).parseZone().format('DD MMM YYYY, HH:mm');
    },

    getStatusName(statusId) {
      const status = this.responseStatuses.find(x => x.id == statusId);

      if (status !== undefined) return status.name;

      return '';
    },

    getStatusText(item) {
      if (item.type !== undefined && item.type !== null) {
        // type 1 - смена статуса
        if (item.type === 1) {
          // Если есть пользователь, то используем его ФИО
          if (item.user_id !== undefined && item.user_id !== null) {
            return this.$tr('response.history.content', {
              user: `${item._embedded.user.userName.first_name || ''} ${
                item._embedded.user.userName.last_name || ''
              } (${item.user_id})`,
              statusOld: item.meta.old_status_id !== undefined ? this.getStatusName(item.meta.old_status_id) : '',
              statusNew: item.meta.new_status_id !== undefined ? this.getStatusName(item.meta.new_status_id) : ''
            });
          } else if (item.user_id === undefined || item.user_id === null) {
            return this.$tr('response.history.contentWithoutUser', {
              statusOld: item.meta.old_status_id !== undefined ? this.getStatusName(item.meta.old_status_id) : '',
              statusNew: item.meta.new_status_id !== undefined ? this.getStatusName(item.meta.new_status_id) : ''
            });
          }
        } else if (item.type === 2) {
          // type 2 - отправлено письмо
          return this.$tr('history.email-with-subject-sent', { subject: item.meta.subject, email: item.meta.to });
        } else if (item.type === 3) {
          // type 3 - Кандидат согласился с политиками и правилами
          return this.$tr('common.user-accepted-privacypolicy');
        } else if (item.type === 4) {
          // type 4 - Кандидат начал этап
          return (
            this.$tr('response.history.candidate-started-stage') +
            ' ' +
            this.$tr(`vacancy.modules.${item.meta.stage_key}.title`)
          );
        } else if (item.type === 5) {
          // type 5 - Кандидат закончил этап
          return (
            this.$tr('response.history.candidate-finished-stage') +
            ' ' +
            this.$tr(`vacancy.modules.${item.meta.stage_key}.title`)
          );
        } else if (item.type === 6 && item.children !== undefined) {
          return this.$tr('responses.tabs.history.fraud');
        } else if (item.type === 6 && item.children === undefined) {
          if (item.meta['cheating-event'] && item.meta.question_title === undefined) {
            if (item.meta['cheating-event'] === 'printscreen-pressed') {
              return this.$tr('response.history.printscreen');
            } else if (item.meta['cheating-event'] === 'focus-changed') {
              return this.$tr('response.history.focus');
            }
          } else if (item.meta['cheating-event'] && item.meta.question_title !== undefined) {
            const stringLength = 100;
            const title =
              item.meta.question_title.length > stringLength
                ? item.meta.question_title.slice(0, stringLength) + '...'
                : item.meta.question_title;

            return this.$tr(`response.history.question.${item.meta['cheating-event']}`, { question: title });
          }
        }
      } else {
        return this.$tr('common.user-accepted-privacypolicy');
      }
    },

    toggleOrLink(item) {
      if (item.type === 6 && item.children !== undefined) {
        this.$emit('toggle-children-menu', item);

        return;
      }

      if (item.type === 6 && item.meta.question_id !== undefined) {
        this.setActiveTab({ name: 'test' });
        this.$router.push({ path: this.$route.path, query: { questionId: item.meta.question_id } });
      }

      return;
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-history-item {
  font-size: 16px;
  display: flex;
  align-items: flex-start;
  padding-bottom: 20px;

  .icon {
    transition: color 0.5s;
  }

  &__list-item-date {
    flex: 0 0 165px;
    margin-right: 6px;
    line-height: 1.6;
    margin-top: -5px;
  }

  &__list-item-type {
    font-size: 18px;
    flex: 0 0 22px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    margin-top: 3px;
    transition: color 0.3s;

    &--lilac {
      color: $lilac;
      font-size: 19px;
    }

    &--blue {
      color: $blue-light-dark;
    }

    &--grey {
      color: $grey;
    }

    &--green {
      color: $green;
    }

    &--yellow {
      color: $yellow;
    }
  }

  &__list-item-type-text {
    display: flex;
    align-items: center;

    &.link {
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: $green;
        transition: color 0.3s;
      }
    }

    i {
      margin-top: -2px;
      margin-left: 7px;
      color: $grey;
    }
  }

  &__list-item-event {
    line-height: 1.6;
    margin-top: -5px;
    width: 100%;
    display: flex;
    justify-content: start;
    align-items: flex-start;
  }

  &.is-child {
    border-left: 1px solid $grey-light;

    .tab-history-item__list-item-type-text {
      font-size: 14px;
    }

    .tab-history-item__list-item-date {
      font-size: 14px;
      padding-left: 10px;
    }

    &:last-child {
      padding-bottom: 0;
      margin-bottom: 20px;
    }
  }
}
</style>
